var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbp-list-requests-main-header"},[_c('h2',{staticClass:"bbp-title-page"},[_vm._v("\n    List of Requests\n  ")]),_vm._v(" "),_c('ListOfRequestsEarnings',{attrs:{"totalAmount":_vm.totalAmount}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3be5c0f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Requests/ListOfRequests/ListOfRequestsHeader.vue
// module id = null
// module chunks = 